module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 py-3"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.licenseUsage) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "month-year layout row wrap",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.licenseUsage.month) ? _c('p', {
    staticClass: "pa-3 ma-0"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.labels.month) + ":\n          "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.months[parseInt(_vm.licenseUsage.month, 10) - 1].text))])]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.year) ? _c('p', {
    staticClass: "pa-3 ma-0"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.labels.year) + ":\n          "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.licenseUsage.year))])]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('p', {
    staticClass: "pa-3 ma-0"
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.labels.rgu) + ":\n          "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.counter))])]) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.productionLicenses))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.testLicense))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.totalActive))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.noOfActiveProdLicenses || 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.noOfActiveTestLicenses || 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.totalConcurrent))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.concurrentUsersForProdLicense || 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.concurrentUsersForTestLicense || 0))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.active))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.inactive))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.registeredUsers))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.noOfActiveUsers || 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.noOfInactiveUsers || 0))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.active))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.inactive))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.domains))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.domainResourceDetails ? _vm.licenseUsage.domainResourceDetails.noOfActiveDomains : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.domainResourceDetails ? _vm.licenseUsage.domainResourceDetails.noOfInactiveDomains : 0))])])])])]), _vm._v(" "), (_vm.licenseUsage.webSpaceDetails) ? _c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.webSpaceTypes))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.active))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.inactive))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.premium))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.premium ? _vm.licenseUsage.webSpaceDetails.premium.noOfActiveWebSpaces : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.premium ? _vm.licenseUsage.webSpaceDetails.premium.noOfInactiveWebSpaces : 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.basic))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.basic ? _vm.licenseUsage.webSpaceDetails.basic.noOfActiveWebSpaces : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.basic ? _vm.licenseUsage.webSpaceDetails.basic.noOfInactiveWebSpaces : 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.link))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.link ? _vm.licenseUsage.webSpaceDetails.link.noOfActiveWebSpaces : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.link ? _vm.licenseUsage.webSpaceDetails.link.noOfInactiveWebSpaces : 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.custom))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.custom ? _vm.licenseUsage.webSpaceDetails.custom.noOfActiveWebSpaces : 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webSpaceDetails.custom ? _vm.licenseUsage.webSpaceDetails.custom.noOfInactiveWebSpaces : 0))])])])])]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.webShopResourceDetails) ? _c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light my-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.active))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.inactive))]), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('th', {
    staticClass: "customHeader"
  }, [_c('td', {
    staticClass: "topHeader"
  }, [_vm._v(_vm._s(_vm.$lang.header.webshop))]), _vm._v(" "), _c('td', {
    staticClass: "bottomHeader column text-xs-center",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('th', {
    staticClass: "bottomHeader column text-xs-center",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('th', {
    staticClass: "customHeader"
  }, [_c('td', {
    staticClass: "topHeader"
  }, [_vm._v(_vm._s(_vm.$lang.header.orderingApp))]), _vm._v(" "), _c('td', {
    staticClass: "bottomHeader column text-xs-center",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('th', {
    staticClass: "bottomHeader column text-xs-center",
    attrs: {
      "role": "columnheader",
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$lang.license.webShopRes))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webShopResourceDetails.noOfActiveWebShopResources || 0))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.webShopResourceDetails.noOfInactiveWebShopResources || 0))]), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.licenseUsage.webShopResourceDetails.ordersData.webshop ? _vm.licenseUsage.webShopResourceDetails.ordersData.webshop.noOfOrders : '-') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.licenseUsage.webShopResourceDetails.ordersData.webshop ? _vm.licenseUsage.webShopResourceDetails.ordersData.webshop.ordersSum : '-') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.licenseUsage.webShopResourceDetails.ordersData['ordering app'] ? _vm.licenseUsage.webShopResourceDetails.ordersData['ordering app'].noOfOrders : '-') + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? _c('td', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                  " + _vm._s(_vm.licenseUsage.webShopResourceDetails.ordersData['ordering app'] ? _vm.licenseUsage.webShopResourceDetails.ordersData['ordering app'].ordersSum : '-') + "\n                ")]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), (_vm.licenseUsage.userDetails) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "v-table__overflow pa-3"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.category))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.module))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.users))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.moon))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.paymentM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Payment Management'] ? _vm.licenseUsage.userDetails['Payment Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.contactM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Contact Management'] ? _vm.licenseUsage.userDetails['Contact Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.reportsM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Reports Management'] ? _vm.licenseUsage.userDetails['Reports Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.ordertM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Order Management'] ? _vm.licenseUsage.userDetails['Order Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.invoiceM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Invoice Management'] ? _vm.licenseUsage.userDetails['Invoice Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.inventoryM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Inventory Management'] ? _vm.licenseUsage.userDetails['Inventory Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.drawerHandlerM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Drawer Handler Management'] ? _vm.licenseUsage.userDetails['Drawer Handler Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.DBOptM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['DB Optimization Management'] ? _vm.licenseUsage.userDetails['DB Optimization Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.moonBackupM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Moon Backup Management'] ? _vm.licenseUsage.userDetails['Moon Backup Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v(_vm._s(_vm.$lang.license.sun))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.autoJobM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['AutoJob Management'] ? _vm.licenseUsage.userDetails['AutoJob Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.catalogM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Catalog Management'] ? _vm.licenseUsage.userDetails['Catalog Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.printerM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Printer Management'] ? _vm.licenseUsage.userDetails['Printer Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.printServerM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['PrintServer Management'] ? _vm.licenseUsage.userDetails['PrintServer Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.licenseM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['License Management'] ? _vm.licenseUsage.userDetails['License Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.tableM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Table Management'] ? _vm.licenseUsage.userDetails['Table Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.accountM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Account Management'] ? _vm.licenseUsage.userDetails['Account Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.companyM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Company Management'] ? _vm.licenseUsage.userDetails['Company Management'].noOfUsers : 0))])]), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.sunBackupM))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseUsage.userDetails['Sun Backup Management'] ? _vm.licenseUsage.userDetails['Sun Backup Management'].noOfUsers : 0))])])])])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.licenseUsage) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-3": ""
    }
  }, [_c('h2', {
    staticClass: "title mb-3"
  }, [_vm._v(_vm._s(_vm.$lang.license.userCounts))]), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? [(_vm.licenseUsage.aggregateUserCountsPerLicenseType) ? _vm._l((_vm.aggUserCountPerLicenseType), function(data, index) {
    return (_vm.aggUserCountPerLicenseType.length > 0) ? _c('div', {
      key: index,
      class: {
        'mt-3': index === _vm.aggUserCountPerLicenseType.length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(data.type))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-0 my-table",
      attrs: {
        "headers": _vm.userCOuntPerLTHeaders,
        "items": data.companies,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "index-w"
          }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
            staticClass: "success--text width-adj"
          }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center success--text"
          }, [_vm._v(_vm._s(props.item.noOfConcurrentUsers))])]
        }
      }], null, true)
    })], 1) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "daily" || _vm.licenseUsage.type === "monthly") ? [(_vm.licenseUsage.userCountsPerLicenseType) ? _vm._l((_vm.userCountPerLicenseType), function(data, index) {
    return (_vm.userCountPerLicenseType.length > 0) ? _c('div', {
      key: index,
      class: {
        'mt-3': index === _vm.userCountPerLicenseType.length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(data.type))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-0 my-table",
      attrs: {
        "headers": _vm.userCOuntPerLTHeaders,
        "items": data.companies,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "index-w"
          }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
            staticClass: "success--text width-adj"
          }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
            staticClass: "text-xs-center success--text"
          }, [_vm._v(_vm._s(props.item.noOfConcurrentUsers))])]
        }
      }], null, true)
    })], 1) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.licenseUsage) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-3": ""
    }
  }, [_c('h2', {
    staticClass: "title mb-2"
  }, [_vm._v(_vm._s(_vm.$lang.license.domainsByWSType))]), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? [(_vm.licenseUsage.aggregateDomainNamesPerWebSpaceType) ? _vm._l((_vm.aggDomainsPerWebSpace), function(data, index) {
    return (_vm.aggDomainsPerWebSpace.length > 0) ? _c('div', {
      key: index,
      class: {
        'mb-3': index !== _vm.aggDomainsPerWebSpace.length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(data.type))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-0 my-table",
      attrs: {
        "headers": _vm.domainsPerWSHeaders,
        "items": data.companies,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "index-w"
          }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
            staticClass: "width-adj"
          }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
            staticClass: "success--text"
          }, [_vm._v(_vm._s(props.item.domainNames.join(', ')))])]
        }
      }], null, true)
    })], 1) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "daily" || _vm.licenseUsage.type === "monthly") ? [(_vm.licenseUsage.domainNamesPerWebSpaceType) ? _vm._l((_vm.getSortedKeys(_vm.licenseUsage.domainNamesPerWebSpaceType)), function(type, index) {
    return (_vm.getSortedKeys(_vm.licenseUsage.domainNamesPerWebSpaceType).length > 0) ? _c('div', {
      key: index,
      class: {
        'mb-3': index !== _vm.getSortedKeys(_vm.licenseUsage.domainNamesPerWebSpaceType).length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-3"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(type))]), _vm._v(" "), _c('div', {
      staticClass: "v-table__overflow"
    }, [_c('table', {
      staticClass: "v-datatable v-table theme--light"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "index-w"
    }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.domainNames))])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "success--text"
    }, [_vm._v(_vm._s(_vm.licenseUsage.domainNamesPerWebSpaceType[type].join(', ')))])])])])])]) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.licenseUsage) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-3": ""
    }
  }, [_c('h2', {
    staticClass: "title mb-3"
  }, [_vm._v(_vm._s(_vm.$lang.license.webShopResourceByType))]), _vm._v(" "), (_vm.licenseUsage.type === "monthlyaggregated") ? [(_vm.licenseUsage.aggregatedWebShopResourcesPerSubscriptionModel) ? _vm._l((_vm.webshopResPerSub), function(data, index) {
    return (_vm.webshopResPerSub.length > 0) ? _c('div', {
      key: index,
      class: {
        'mb-3': index !== _vm.webshopResPerSub.length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-3"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(data.type))]), _vm._v(" "), _c('v-data-table', {
      staticClass: "elevation-0 my-table",
      attrs: {
        "headers": _vm.webshopResPerSubHeaders,
        "items": data.companies,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "headers",
        fn: function(props) {
          return [_c('tr', [_c('th', {
            staticClass: "bottomHeader column text-xs-left"
          }, [_vm._v("#")]), _vm._v(" "), _c('th', {
            staticClass: "bottomHeader column text-xs-left"
          }, [_vm._v(_vm._s(_vm.$lang.license.companyName))]), _vm._v(" "), _c('th', {
            staticClass: "bottomHeader column text-xs-left"
          }, [_vm._v(_vm._s(_vm.$lang.license.webShopResourceName))]), _vm._v(" "), _c('th', {
            staticClass: "bottomHeader column text-xs-left"
          }, [_vm._v(_vm._s(_vm.$lang.license.webShopResourceId))]), _vm._v(" "), _c('th', {
            staticClass: "customHeader"
          }, [_c('td', {
            staticClass: "topHeader"
          }, [_vm._v(_vm._s(_vm.$lang.header.webshop))]), _vm._v(" "), _c('td', {
            staticClass: "bottomHeader column",
            attrs: {
              "role": "columnheader",
              "scope": "col"
            }
          }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]), _vm._v(" "), _c('th', {
            staticClass: "bottomHeader column",
            attrs: {
              "role": "columnheader",
              "scope": "col"
            }
          }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))]), _vm._v(" "), _c('th', {
            staticClass: "customHeader"
          }, [_c('td', {
            staticClass: "topHeader"
          }, [_vm._v(_vm._s(_vm.$lang.header.orderingApp))]), _vm._v(" "), _c('td', {
            staticClass: "bottomHeader column",
            attrs: {
              "role": "columnheader",
              "scope": "col"
            }
          }, [_vm._v(_vm._s(_vm.$lang.license.orders))])]), _vm._v(" "), _c('th', {
            staticClass: "bottomHeader column",
            attrs: {
              "role": "columnheader",
              "scope": "col"
            }
          }, [_vm._v(_vm._s(_vm.$lang.license.totalAmount))])])]
        }
      }, {
        key: "items",
        fn: function(props) {
          return [_c('td', {
            staticClass: "index-w"
          }, [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', {
            staticClass: "width-adj"
          }, [_vm._v(_vm._s(props.item.companyName))]), _vm._v(" "), _c('td', {
            staticClass: "width-adj"
          }, [_vm._v(_vm._s(props.item.webShopResourceName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.webShopResourceId))]), _vm._v(" "), _c('td', {
            staticClass: "success--text"
          }, [_vm._v(_vm._s(_vm.getOrderData(props.item.ordersData, 'webshop', 'noOfOrders')))]), _vm._v(" "), _c('td', {
            staticClass: "success--text"
          }, [_vm._v(_vm._s(_vm.getOrderData(props.item.ordersData, 'webshop', 'ordersSum')))]), _vm._v(" "), _c('td', {
            staticClass: "success--text"
          }, [_vm._v(_vm._s(_vm.getOrderData(props.item.ordersData, 'ordering app', 'noOfOrders')))]), _vm._v(" "), _c('td', {
            staticClass: "success--text"
          }, [_vm._v(_vm._s(_vm.getOrderData(props.item.ordersData, 'ordering app', 'ordersSum')))])]
        }
      }], null, true)
    })], 1) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e(), _vm._v(" "), (_vm.licenseUsage.type === "daily" || _vm.licenseUsage.type === "monthly") ? [(_vm.licenseUsage.webShopResourcesPerSubscriptionModel) ? _vm._l((_vm.getSortedKeys(_vm.licenseUsage.webShopResourcesPerSubscriptionModel)), function(type, index) {
    return (_vm.getSortedKeys(_vm.licenseUsage.webShopResourcesPerSubscriptionModel).length > 0) ? _c('div', {
      key: index,
      class: {
        'mb-3': index !== _vm.getSortedKeys(_vm.licenseUsage.webShopResourcesPerSubscriptionModel).length - 1
      }
    }, [_c('h3', {
      staticClass: "sub-title mb-2"
    }, [_c('span', [_vm._v(_vm._s(_vm.$lang.license.type) + ":")]), _vm._v(" " + _vm._s(type))]), _vm._v(" "), _c('div', {
      staticClass: "v-table__overflow"
    }, [_c('table', {
      staticClass: "v-datatable v-table theme--light"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "index-w"
    }, [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.webShopResourceName))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$lang.license.webShopResourceId))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.licenseUsage.webShopResourcesPerSubscriptionModel[type]), function(resource, index2) {
      return _c('tr', {
        key: index2
      }, [_c('td', [_vm._v(_vm._s(index2 + 1))]), _vm._v(" "), _c('td', {
        staticClass: "success--text width-adj"
      }, [_vm._v(_vm._s(resource.webShopResourceName))]), _vm._v(" "), _c('td', {
        staticClass: "success--text"
      }, [_vm._v(_vm._s(resource.webShopResourceId))])])
    }), 0)])])]) : _vm._e()
  }) : _c('div', [_vm._v("No data available.")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n      " + _vm._s(_vm.$lang.actions.close) + "\n    ")], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69d10534","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/LicenseReportDetailsModal.vue
// module id = 585
// module chunks = 10